<template>
  <v-col cols="12" :md="md">
    <v-container>
      <div id="chart" v-if="showChart">
        <apexchart type="bar" height="200" :options="chartOptions" :series="series"></apexchart>
      </div>
    </v-container>
  </v-col>
</template>
<script>
import WorkloadService from "@/modules/display/services/workload-service";

export default {
  name: "ChartField",
  components: {
    apexchart: () => import("vue-apexcharts")
  },
  props: {
    item: Object,
    md: String
  },
  data() {
    return {
      showChart: false,
      series: [],
      chartOptions: {
        colors:[],
        chart: {
          type: 'bar',
          height: 200,
          stacked: true
        },
        responsive: [{
          breakpoint: 480,
          options: {
            legend: {
              position: 'bottom',
              offsetX: -10,
              offsetY: 0
            }
          }
        }],
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 10
          },
        },
        legend: {
          position: 'right',
          offsetY: 40
        },
        fill: {
          opacity: 1
        }
      },
    }
  },
  created() {
    WorkloadService.getStatisticChart(
      this.item.id,
      (response) => {
        let chartData = response.data;

        if (typeof chartData === 'object' && chartData !== null) {
          this.chartOptions.xaxis = { categories: chartData.data.labels };


          chartData.data.datasets.forEach(
            (item) => {
              this.series.push({name: item.label, data: item.data});
              this.chartOptions.colors.push(item.backgroundColor);
            }
          );

          this.showChart = true;
        }
      }
    )
  }
}
</script>